import apiClient from './client';
import { OTJRecord, ProgressReview } from '../types';

export const trackingApi = {
  // OTJ Records
  createOTJ: (data: Partial<OTJRecord>) =>
    apiClient.post<OTJRecord>('/tracking/otj', data),
  
  getOTJRecords: (tenantId: string, apprenticeId: string) =>
    apiClient.get<OTJRecord[]>(`/tracking/otj/tenant/${tenantId}/apprentice/${apprenticeId}`),
  
  updateOTJ: (tenantId: string, id: string, data: Partial<OTJRecord>) =>
    apiClient.patch<OTJRecord>(`/tracking/otj/tenant/${tenantId}/${id}`, data),
  
  deleteOTJ: (tenantId: string, id: string) =>
    apiClient.delete(`/tracking/otj/tenant/${tenantId}/${id}`),
  
  verifyOTJ: (tenantId: string, id: string, verifiedBy: string, status: 'approved' | 'rejected') =>
    apiClient.post(`/tracking/otj/tenant/${tenantId}/${id}/verify`, {
      verified_by: verifiedBy,
      status
    }),
  
  // Progress Reviews
  createReview: (data: Partial<ProgressReview>) =>
    apiClient.post<ProgressReview>('/tracking/reviews', data),
  
  getReviews: (tenantId: string, apprenticeId: string) =>
    apiClient.get<ProgressReview[]>(`/tracking/reviews/tenant/${tenantId}/apprentice/${apprenticeId}`),
  
  updateReview: (tenantId: string, id: string, data: Partial<ProgressReview>) =>
    apiClient.patch<ProgressReview>(`/tracking/reviews/tenant/${tenantId}/${id}`, data),
  
  signReview: (tenantId: string, id: string, data: { signature_type: 'employer' | 'apprentice' }) =>
    apiClient.post(`/tracking/reviews/tenant/${tenantId}/${id}/sign`, data),
};
